import { localUrl as appLocalUrl } from './app-path.js';
import ApiClient from './api-client';
import SessionManager from './session-manager';
import { trackGa4CatalogEvent } from './analytics/ga4-event-tracker';

const RecoverPassword = {
	currentEmail: null,
	currentOtp: null,

	getTrackingIdentity: function () {
		const sessionUserId = SessionManager.getUserData()?.userId;
		let iumc = null;

		try {
			const raw = localStorage.getItem('ct_mc');
			if (raw) {
				const parsed = JSON.parse(raw);
				iumc = parsed?.mcid || null;
			}
		} catch (_) {
			iumc = null;
		}

		return {
			user_id: sessionUserId || undefined,
			userid: iumc || undefined,
		};
	},

	init: function () {
		if (!document.querySelector('.step-1-content')) {
			return;
		}

		RecoverPassword.setupElements();
		RecoverPassword.setupEventListeners();
		RecoverPassword.setupCodeInputs();
		RecoverPassword.setupInputMasks();
	},

	showMessage: function (container, message, type = 'error', duration = 5000) {
		const messageClass =
			type === 'success' ? 'success-message' : 'error-message';
		const $container = typeof container === 'string' ? $(container) : container;

		$container.find('.success-message, .error-message').remove();

		const $message = $(`<div class="${messageClass}">${message}</div>`);
		$container.prepend($message);

		const fadeDelay = type === 'success' ? 3000 : duration;
		setTimeout(() => {
			$message.fadeOut(() => $message.remove());
		}, fadeDelay);
	},

	setButtonLoading: function (button, isLoading, loadingText, defaultText) {
		if (!button) return;

		if (isLoading) {
			button.disabled = true;
			if (button.tagName === 'INPUT') {
				button.value = loadingText;
			} else {
				button.textContent = loadingText;
			}
			return;
		}

		button.disabled = false;
		if (button.tagName === 'INPUT') {
			button.value = defaultText;
		} else {
			button.textContent = defaultText;
		}
	},

	resolveOtpValidationErrorMessage: function (responseOrError) {
		const errorText = String(
			responseOrError?.error ||
				responseOrError?.message ||
				responseOrError?.errorDetails ||
				'',
		).toLowerCase();

		if (
			errorText.includes('invalid') ||
			errorText.includes('expired') ||
			errorText.includes('otp') ||
			errorText.includes('código')
		) {
			return 'Código inválido ou expirado. Verifique e tente novamente.';
		}

		return 'Erro ao validar código. Tente novamente.';
	},

	setupElements: function () {
		RecoverPassword.step1 = document.querySelector('.step-1-content');
		RecoverPassword.step2 = document.querySelector('.step-2-content');
		RecoverPassword.step3 = document.querySelector('.step-3-content');
		RecoverPassword.step4 = document.querySelector('.step-4-content');

		RecoverPassword.stepIndicator1 = document.querySelector('.step-1');
		RecoverPassword.stepIndicator2 = document.querySelector('.step-2');
		RecoverPassword.stepIndicator3 = document.querySelector('.step-3');
		RecoverPassword.stepsContainer = document.querySelector('.steps');

		RecoverPassword.goStep2Btn = document.getElementById('goStep2');
		RecoverPassword.goStep3Btn = document.getElementById('goStep3');
		RecoverPassword.resetPasswordBtn = document.getElementById(
			'btnSendPasswordRecover',
		);
		RecoverPassword.backStep1Btn = document.getElementById('backStep1');
		RecoverPassword.resendOTPBtn = document.getElementById('resendOTP');

		RecoverPassword.emailInput = document.getElementById('emailInputRecover');
		RecoverPassword.codeInputs = document.querySelectorAll('.otp-input');

		if (
			!RecoverPassword.step1 ||
			!RecoverPassword.step2 ||
			!RecoverPassword.step3 ||
			!RecoverPassword.step4
		) {
			console.error('Step elements not found');
			return;
		}
	},

	setupEventListeners: function () {
		console.log('🔧 setupEventListeners - iniciando');

		const formStep1 = document.getElementById('formSendPasswordRecover');
		console.log('📝 formStep1:', formStep1);
		if (formStep1) {
			formStep1.addEventListener(
				'submit',
				function (e) {
					e.preventDefault();

					const email = RecoverPassword.emailInput.value.trim();
					if (!RecoverPassword.validateEmail(email)) {
						RecoverPassword.showMessage(
							'.step-1-content',
							'Por favor, insira um e-mail válido.',
						);
						return;
					}

					RecoverPassword.sendOtpToEmail(email);
				},
				{ passive: false },
			);
		}

		const formStep2 = document.getElementById('formValidateOTP');
		if (formStep2) {
			formStep2.addEventListener(
				'submit',
				function (e) {
					e.preventDefault();

					const code = RecoverPassword.getCode();
					if (code.length !== 6) {
						RecoverPassword.showMessage(
							'.step-2-content',
							'Por favor, insira o código completo.',
						);
						return;
					}

					RecoverPassword.verifyOtpCode(code);
				},
				{ passive: false },
			);
		}

		if (RecoverPassword.backStep1Btn) {
			RecoverPassword.backStep1Btn.addEventListener(
				'click',
				function (e) {
					e.preventDefault();
					RecoverPassword.goToStep(1);
				},
				{ passive: false },
			);
		}

		const formStep3 = document.getElementById('formResetPassword');
		console.log('📝 formStep3 (resetPassword):', formStep3);
		if (formStep3) {
			console.log('✅ Registrando listener para formResetPassword');
			formStep3.addEventListener(
				'submit',
				function (e) {
					console.log('🚀 Submit do formResetPassword disparado!');
					e.preventDefault();
					e.stopPropagation();
					e.stopImmediatePropagation();
					RecoverPassword.resetPassword();
				},
				{ passive: false, capture: true },
			);
		} else {
			console.error('❌ formResetPassword NÃO encontrado!');
		}

		if (RecoverPassword.resendOTPBtn) {
			RecoverPassword.resendOTPBtn.addEventListener(
				'click',
				function (e) {
					e.preventDefault();
					if (RecoverPassword.currentEmail) {
						RecoverPassword.sendOtpToEmail(RecoverPassword.currentEmail);
					}
				},
				{ passive: false },
			);
		}

		RecoverPassword.setupPasswordToggle();
	},

	setupCodeInputs: function () {
		if (!RecoverPassword.codeInputs || RecoverPassword.codeInputs.length === 0)
			return;

		RecoverPassword.codeInputs.forEach(function (input, index) {
			input.addEventListener('input', function (e) {
				if (
					e.target.value.length === 1 &&
					index < RecoverPassword.codeInputs.length - 1
				) {
					RecoverPassword.codeInputs[index + 1].focus();
				}
			});

			input.addEventListener('keydown', function (e) {
				if (e.key === 'Backspace' && e.target.value === '' && index > 0) {
					RecoverPassword.codeInputs[index - 1].focus();
				}
			});

			input.addEventListener('keypress', function (e) {
				if (!/[0-9]/.test(e.key)) {
					e.preventDefault();
				}
			});

			input.addEventListener(
				'paste',
				function (e) {
					e.preventDefault();
					const pastedData = e.clipboardData.getData('text');
					const digits = pastedData.replace(/\D/g, '').split('');

					digits.forEach(function (digit, i) {
						if (index + i < RecoverPassword.codeInputs.length) {
							RecoverPassword.codeInputs[index + i].value = digit;
						}
					});

					const lastIndex = Math.min(
						index + digits.length - 1,
						RecoverPassword.codeInputs.length - 1,
					);
					RecoverPassword.codeInputs[lastIndex].focus();
				},
				{ passive: false },
			);
		});
	},

	validateEmail: function (email) {
		const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return re.test(email);
	},

	getCode: function () {
		let code = '';
		RecoverPassword.codeInputs.forEach(function (input) {
			code += input.value;
		});
		return code;
	},

	goToStep: function (stepNumber) {
		[
			RecoverPassword.step1,
			RecoverPassword.step2,
			RecoverPassword.step3,
			RecoverPassword.step4,
		].forEach(step => {
			if (step) step.classList.remove('active');
		});

		switch (stepNumber) {
			case 1:
				if (RecoverPassword.step1)
					RecoverPassword.step1.classList.add('active');
				if (RecoverPassword.stepIndicator2)
					RecoverPassword.stepIndicator2.classList.remove('active');
				if (RecoverPassword.stepIndicator3)
					RecoverPassword.stepIndicator3.classList.remove('active');
				setTimeout(() => {
					if (RecoverPassword.emailInput) RecoverPassword.emailInput.focus();
				}, 100);
				RecoverPassword.clearCodeInputs();
				break;
			case 2:
				if (RecoverPassword.step2)
					RecoverPassword.step2.classList.add('active');
				if (RecoverPassword.stepIndicator1)
					RecoverPassword.stepIndicator1.classList.add('active');
				if (RecoverPassword.stepIndicator2)
					RecoverPassword.stepIndicator2.classList.add('active');

				setTimeout(() => {
					if (RecoverPassword.codeInputs && RecoverPassword.codeInputs[0]) {
						RecoverPassword.codeInputs[0].focus();
					}
				}, 100);
				break;
			case 3:
				if (RecoverPassword.step3)
					RecoverPassword.step3.classList.add('active');
				if (RecoverPassword.stepIndicator2)
					RecoverPassword.stepIndicator2.classList.add('active');
				if (RecoverPassword.stepIndicator3)
					RecoverPassword.stepIndicator3.classList.add('active');

				setTimeout(() => {
					const step3Inputs = ['passwordInput', 'repeatPasswordInput'];
					step3Inputs.forEach(function (inputId) {
						const input = document.getElementById(inputId);
						if (input && input.value.trim().length > 0) {
							input.classList.add('has-value');
						}
					});
					const passwordInput = document.getElementById('passwordInput');
					if (passwordInput) passwordInput.focus();
				}, 100);
				break;
			case 4:
				if (RecoverPassword.stepsContainer)
					RecoverPassword.stepsContainer.classList.add('hidden');

				if (RecoverPassword.step4)
					RecoverPassword.step4.classList.add('active');
				break;
		}
	},

	sendOtpToEmail: async function (email) {
		const button = RecoverPassword.goStep2Btn || RecoverPassword.resendOTPBtn;
		const originalText = button
			? button.tagName === 'INPUT'
				? button.value
				: button.textContent
			: '';
		RecoverPassword.setButtonLoading(button, true, 'Enviando...', originalText);

		try {
			const response = await ApiClient.bffPost('/password/generate-otp', {
				email: email,
			});

			RecoverPassword.setButtonLoading(
				button,
				false,
				'Enviando...',
				originalText,
			);

			if (response.success) {
				RecoverPassword.currentEmail = email;
				trackGa4CatalogEvent('request_password_attempt', {
					...RecoverPassword.getTrackingIdentity(),
				});

				console.log('✅ Código de recuperação enviado para:', email);

				RecoverPassword.showMessage(
					'.step-1-content',
					response.data?.message || 'Código enviado com sucesso!',
					'success',
				);

				setTimeout(() => {
					RecoverPassword.goToStep(2);
					RecoverPassword.startResendTimer();
				}, 1000);
			} else {
				console.error('Erro ao enviar OTP (detalhes):', response.errorDetails);
				RecoverPassword.showMessage(
					'.step-1-content',
					response.error ||
						'Erro ao enviar código de verificação. Verifique o email informado.',
				);
			}
		} catch (error) {
			RecoverPassword.setButtonLoading(
				button,
				false,
				'Enviando...',
				originalText,
			);
			console.error('Error:', error);
			RecoverPassword.showMessage(
				'.step-1-content',
				error.message || 'Erro ao conectar com o servidor. Tente novamente.',
			);
		}
	},

	verifyOtpCode: async function (code) {
		if (!RecoverPassword.currentEmail) {
			RecoverPassword.showMessage(
				'.step-2-content',
				'E-mail não encontrado. Volte e informe novamente.',
			);
			return;
		}

		const button = RecoverPassword.goStep3Btn;
		const originalText = button
			? button.tagName === 'INPUT'
				? button.value
				: button.textContent
			: '';
		RecoverPassword.setButtonLoading(
			button,
			true,
			'Verificando...',
			originalText,
		);

		try {
			const response = await ApiClient.bffPost('/password/validate-otp', {
				email: RecoverPassword.currentEmail,
				code: code,
			});

			RecoverPassword.setButtonLoading(
				button,
				false,
				'Verificando...',
				originalText,
			);

			if (response.success) {
				RecoverPassword.currentOtp = code;
				RecoverPassword.showMessage(
					'.step-2-content',
					response.data?.message || 'Código validado com sucesso!',
					'success',
				);

				setTimeout(() => {
					RecoverPassword.goToStep(3);
				}, 700);
				return;
			}

			RecoverPassword.showMessage(
				'.step-2-content',
				RecoverPassword.resolveOtpValidationErrorMessage(response),
			);
			RecoverPassword.clearCodeInputs();
		} catch (error) {
			RecoverPassword.setButtonLoading(
				button,
				false,
				'Verificando...',
				originalText,
			);
			console.error('Error:', error);
			RecoverPassword.showMessage(
				'.step-2-content',
				RecoverPassword.resolveOtpValidationErrorMessage(error),
			);
			RecoverPassword.clearCodeInputs();
		}
	},

	resetPassword: async function () {
		const password = document.getElementById('passwordInput')
			? document.getElementById('passwordInput').value
			: '';
		const confirmPassword = document.getElementById('repeatPasswordInput')
			? document.getElementById('repeatPasswordInput').value
			: '';

		if (!password || !confirmPassword) {
			RecoverPassword.showMessage(
				'.step-3-content',
				'Por favor, informe e confirme sua senha.',
			);
			return;
		}

		if (password !== confirmPassword) {
			RecoverPassword.showMessage('.step-3-content', 'As senhas não conferem.');
			return;
		}

		if (password.length < 6) {
			RecoverPassword.showMessage(
				'.step-3-content',
				'A senha deve ter no mínimo 6 caracteres.',
			);
			return;
		}
		if (!/[A-Za-z]/.test(password) || !/[0-9]/.test(password)) {
			RecoverPassword.showMessage(
				'.step-3-content',
				'A senha deve conter pelo menos uma letra e um número.',
			);
			return;
		}
		if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
			RecoverPassword.showMessage(
				'.step-3-content',
				'A senha deve conter pelo menos um caractere especial.',
			);
			return;
		}

		const button = RecoverPassword.resetPasswordBtn;
		const originalText = button.value;
		button.disabled = true;
		button.value = 'Salvando...';

		console.log('🔐 Enviando requisição de reset de senha...');

		try {
			const response = await ApiClient.bffPost('/password/reset', {
				email: RecoverPassword.currentEmail,
				code: RecoverPassword.currentOtp,
				newPassword: password,
			});

			button.disabled = false;
			button.value = originalText;

			if (response.success) {
				trackGa4CatalogEvent('reset_password_attempt', {
					...RecoverPassword.getTrackingIdentity(),
				});

				RecoverPassword.showMessage(
					'.step-3-content',
					response.data?.message || 'Senha redefinida com sucesso!',
					'success',
				);

				setTimeout(() => {
					RecoverPassword.goToStep(4);

					setTimeout(function () {
						window.location.href = appLocalUrl('/login');
					}, 3000);
				}, 1000);
			} else {
				console.error(
					'Erro ao redefinir senha (detalhes):',
					response.errorDetails,
				);
				RecoverPassword.showMessage(
					'.step-3-content',
					response.error || 'Erro ao redefinir senha',
				);
			}
		} catch (error) {
			button.disabled = false;
			button.value = originalText;

			console.error('Error:', error);
			RecoverPassword.showMessage(
				'.step-3-content',
				error.message || 'Erro ao conectar com o servidor. Tente novamente.',
			);
		}
	},

	setupPasswordToggle: function () {
		const toggleButtons = document.querySelectorAll(
			'.actControlPasswordVisible',
		);

		toggleButtons.forEach(function (btn) {
			btn.addEventListener(
				'click',
				function (e) {
					e.preventDefault();

					const passwordInput = this.previousElementSibling;
					if (!passwordInput) return;

					if (passwordInput.type === 'password') {
						passwordInput.type = 'text';
						this.classList.remove('fa-eye');
						this.classList.add('fa-eye-slash');
					} else {
						passwordInput.type = 'password';
						this.classList.remove('fa-eye-slash');
						this.classList.add('fa-eye');
					}
				},
				{ passive: false },
			);
		});
	},

	clearCodeInputs: function () {
		RecoverPassword.codeInputs.forEach(function (input) {
			input.value = '';
		});
		if (RecoverPassword.codeInputs.length > 0) {
			RecoverPassword.codeInputs[0].focus();
		}
	},

	startResendTimer: function () {
		const resendBtn = RecoverPassword.resendOTPBtn;
		const timerElement = document.getElementById('resendTimer');
		const timerSeconds = document.getElementById('timerSeconds');

		if (!resendBtn || !timerElement || !timerSeconds) return;

		let seconds = 60;
		resendBtn.style.display = 'none';
		timerElement.classList.remove('_none');

		const interval = setInterval(function () {
			seconds--;
			timerSeconds.textContent = seconds;

			if (seconds <= 0) {
				clearInterval(interval);
				resendBtn.style.display = 'inline';
				timerElement.classList.add('_none');
			}
		}, 1000);
	},

	setupInputMasks: function () {
		const updateLabelState = function (input) {
			if (!input) return;
			if (input.value.trim().length > 0) {
				input.classList.add('has-value');
			} else {
				input.classList.remove('has-value');
			}
		};

		const inputIds = [
			'emailInputRecover',
			'passwordInput',
			'repeatPasswordInput',
		];
		inputIds.forEach(function (inputId) {
			const input = document.getElementById(inputId);
			if (input) {
				input.addEventListener('input', function (e) {
					updateLabelState(e.target);
				});
				input.addEventListener('blur', function (e) {
					updateLabelState(e.target);
				});
				updateLabelState(input);
			}
		});
	},
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', RecoverPassword.init);
} else {
	RecoverPassword.init();
}

export default RecoverPassword;
